import React from 'react';
import { formatDate } from '~/util';

interface TimelyActionInfoProps {
    reminder: ReminderType;
}

export function TimelyActionInfo({ reminder }: TimelyActionInfoProps) {
    return (
        <div>
            <div className="row mb-3">
                <div className="col-6">
                    <div className="fw-bold">Event Type</div>
                    <div>{reminder.timely_action?.metadata.eventType}</div>
                </div>
                <div className="col-6">
                    <div className="fw-bold">Facility Name</div>
                    <div>{reminder.timely_action?.metadata.facilityName}</div>
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-6">
                    <div className="fw-bold">Event Date</div>
                    <div>{formatDate(reminder.timely_action?.metadata.eventDate)}</div>
                </div>
                <div className="col-6">
                    <div className="fw-bold">Facility Type</div>
                    <div>{reminder.timely_action?.metadata.facilityType}</div>
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-6">
                    <div className="fw-bold">Event Source</div>
                    <div>{reminder.timely_action?.metadata.eventSource}</div>
                </div>
                <div className="col-6">
                    <div className="fw-bold">Admit Type</div>
                    <div>{reminder.timely_action?.metadata.admitType}</div>
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-6">
                    <div className="fw-bold">Chief Complaint</div>
                    <div>{reminder.timely_action?.metadata.chiefComplaint}</div>
                </div>
                <div className="col-6">
                    <div className="fw-bold">Admitting Party</div>
                    <div>{reminder.timely_action?.metadata.admittingParty}</div>
                </div>
            </div>
        </div>
    );
}
